export function criticalChangeSummary(before, after, drivers = []) {
  const changes = [];
  const money = (record, amount, currency) => record[amount] === '' || record[amount] == null
    ? '未填写' : `${record[currency] || 'JPY'} ${Number(record[amount])}`;
  for (const [amount, currency, label] of [
    ['price_amount', 'price_currency', '订单金额'],
    ['driver_collection_amount', 'driver_collection_currency', '司机代收金额'],
  ]) {
    const oldValue = money(before, amount, currency);
    const newValue = money(after, amount, currency);
    if (oldValue !== newValue) changes.push(`${label}：${oldValue} → ${newValue}`);
  }
  if (after.driver_id && before.driver_id !== after.driver_id) {
    const name = id => drivers.find(driver => driver.id === id)?.name || id || '未分配';
    changes.push(`司机：${before.driver_name || name(before.driver_id)} → ${name(after.driver_id)}`);
    changes.push('原司机将不再负责该排班，新司机需要另行确认。');
  }
  return changes.join('\n');
}

export function cancelConfirmation(schedule) {
  return `确认取消排班？\n${schedule.date || ''} ${schedule.time || ''}\n${schedule.pickup_location || ''} → ${schedule.dropoff_location || ''}\n司机：${schedule.driver_name || '未分配'}`;
}

export function showOperationFeedback(data, fallback = '操作已保存') {
  if (data.driver_removed && data.driver_notice_recorded) return;
  window.alert(data.operation_feedback || `${fallback}。未取得司机通知回执，请另行联系司机确认。`);
}
